function PostSummary() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.priority = 1;

    this._MAX_WORDS = 75;
    this._MIN_WORDS = 25;

    this.full = null;

    this.init = function() {
        var exerptregexp = new RegExp("{{( )?excerpt .*\s*}");
        if (exerptregexp.test($(this.node).text())) {
            if (!this.full) {
                var text = $(this.node).text();
                var plusone = 0;
                var index = text.indexOf("{{excerpt");
                if (index < 0) {index = text.indexOf("{{ excerpt"); plusone = 1};
                text = text.substring(index + 9 + plusone);
                var endIndex = text.indexOf("}");
                text = text.substring(0, endIndex);
                $(this.node).html(text.trim());
            } else {
                var text = $(this.node).html();
                var plusone = 0;
                var index = text.indexOf("{{excerpt");
                if (index < 0) {index = text.indexOf("{{ excerpt"); plusone = 1};
                var lastIndex = text.indexOf("}", index);
                text = text.substring(0, lastIndex) + text.substring(lastIndex + 1);
                text = text.substring(0, index) + text.substring(index + 9 + plusone + 1);
                $(this.node).html(text);
                $(this.node).css("display", "block");
                this.recreateMogoComponents();
            }
        } else if (this.full === null) {
            var resultText = "";
            var text = $(this.node).text();
            var textArr = text.split(".");
            var counter = 0;
            while (resultText.split(" ").length < this._MIN_WORDS && counter < textArr.length - 1) {
                resultText = resultText + textArr[counter] + ".";
                counter++;
            }
            if (resultText.split(" ").length > this._MAX_WORDS) {
                var resultTextArr = resultText.split(" ");
                resultTextArr = resultTextArr.splice(0, this._MAX_WORDS);
                resultText = resultTextArr.join(" ") + "...";
            }
            $(this.node).html(resultText);
        } else {
            $(this.node).css("display", "block");
        }
    };

    this.initAllReady = function() {};

    this.recreateMogoComponents = function() {
        var components = $("[data-mogo-ui]", this.node);
        for (var i = 0; i < components.length; i++) {
            var id = components[i].id;
            delete window.mogo.repository()[id];
            for (var j = 0; j < window.mogo.registry.mogoUI.startupArr.length; j++) {
                if (window.mogo.registry.mogoUI.startupArr[j].id == id) {
                    window.mogo.registry.mogoUI.startupArr.splice(j, 1);
                }
            }
            var type = $(components[i]).data("mogo-ui");
            var params = {};
            var dataObj = $(components[i]).data();
            for (var key in dataObj) {
                if (key.indexOf("mogoUi") == 0) {
                    var prop = key.replace("mogoUi", "");
                    if (prop != "") {
                        prop = prop.substring(0, 1).toLowerCase() + prop.substring(1);
                        params[prop] = dataObj[key];
                    }
                }
            }
            $("#" + id, this.node).mogo().create(type, params);
        }
    };
}